module.exports = __webpack_public_path__ + "img/p_healrt.24b73838.png";